
import { Component, Prop, Vue } from 'vue-property-decorator';

// Services
import UserService from '@/utils/UserService';

// Components
import VUserAvatar from '@/components/VUserAvatar.vue';

// Interfaces
import { DesignHistory } from '@/ship/Models/Design';

@Component({
    components: {
        VUserAvatar,
    },
})
export default class PMChartHistoryItem extends Vue {
    @Prop({ type: Object, required: true })
    history!: DesignHistory;

    @Prop({ type: Boolean })
    useGeneralMessage!: boolean;

    get author() {
        return this.history.authorId ? this.history.author?.data : undefined;
    }

    get authorName() {
        return this.history.authorId ? UserService.getShortName(this.author) : '';
    }

    get message() {
        return this.useGeneralMessage ? this.history.generalMessage : this.history.message;
    }

    get subMessage() {
        return this.history.submessage;
    }
}
